import React from 'react';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ProjectAssignmentEditItem from '../../../../Domain/ProjectAssignmentEditItem';
import ProjectAssignmentService from '../../../../Services/ProjectAssignmentsService';

class EditProjectAssignmentWindowDescription extends React.Component {
  static titleForCreate = 'Add New Assignment';
  static titleForEdit = 'Edit Assignment';
  static itemType = ProjectAssignmentEditItem;
  static serviceFunction = (edited) =>
    ProjectAssignmentService.EditMultipleAssignment(
      edited,
      EditProjectAssignmentWindowDescription.getSelected(),
      EditProjectAssignmentWindowDescription.getAllItemInTheSearchAreSelected(),
      EditProjectAssignmentWindowDescription.getSearchParameters()
    );
  static waitForResponseOnWait = false;

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'Ad-Hoc Invoice Group',
      fields: [
        {
          fieldName: 'AdHocInvoiceGroupEnabled',
          label: 'Modify Ad-Hoc Invoice Group?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AdHocInvoiceGroup',
          label: 'Ad-Hoc Invoice Group',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.AdHocInvoiceGroupEnabled !== true,
        },
      ],
    },
    {
      label: 'Uninvoiceable',
      fields: [
        {
          fieldName: 'UninvoiceableEnabled',
          label: 'Modify Uninvoiceable',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Uninvoiceable',
          label: 'Uninvoiceable?',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.UninvoiceableEnabled !== true,
        },
      ],
    },
    {
      label: 'Paid Outside of System',
      fields: [
        {
          fieldName: 'PaidOutsideOfSystemEnabled',
          label: 'Modify Paid Outside of System',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PaidOutsideOfSystem',
          label: 'Paid Outside of System?',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.PaidOutsideOfSystemEnabled !== true,
        },
      ],
    },
  ];
}

export default EditProjectAssignmentWindowDescription;
